import { GiftCardConfirmationModalScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GiftCardConfirmationModalScreen />;
}
